import React from 'react'
import TextInput from '../../../../components/TextInput';
import { useSelector } from 'react-redux';
import Dropdown from '../../../../components/Dropdown';
import MonthRangePicker from '../../../../components/MonthRangePicker';

const AlumniSection = ({ formAdvanceData, setFormAdvanceData, handleChange, handleSearchTalent }) => {
  const { resignationReasonOptions } = useSelector((state: any) => state.companyTalent);
  
  return (
    <>
      <p className='text-sm font-bold alu-text-base-2 mb-6'>アルムナイ</p>
      <div className='flex flex-col gap-8'>
        <div className='grid grid-cols-3 gap-10'>
          <div className='col-span-1'>
            <label className="block text-sm mb-2 alu-text-base-1">最終部署・社名</label>
            <TextInput
              size="md"
              name="department"
              value={formAdvanceData.department}
              onChange={handleChange}
              onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
              placeholder=""
              clearIcon={true}
              onClearQuery={() => {
                setFormAdvanceData((prev: any) => ({
                  ...prev,
                  department: '',
                }));
              }}
            />
          </div>
          <div className='col-span-1'>
            <label className="block text-sm mb-2 alu-text-base-1">退職理由</label>
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={resignationReasonOptions}
              placeholder=""
              value={formAdvanceData.reason_resignation}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, reason_resignation: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="col-span-1"></div>
        </div>

        <div className='grid grid-cols-2 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">入社年月</label>
            {/* activity_level */}
            <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <MonthRangePicker
                  anchor="bottom"
                  placeholderStart=""
                  placeholderEnd=""
                  type={3}
                  startMonth={formAdvanceData.date_join_company_start}
                  endMonth={formAdvanceData?.date_join_company_end ? formAdvanceData?.date_join_company_end : ''}
                  onChange={(start: any, end: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, date_join_company_start: start, date_join_company_end: end }))
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">退社年月</label>
            <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <MonthRangePicker
                  anchor="bottom"
                  placeholderStart=""
                  placeholderEnd=""
                  type={3}
                  startMonthDisabledTime={formAdvanceData.date_join_company_start}
                  startMonth={formAdvanceData.date_leave_company_start}
                  endMonth={formAdvanceData?.date_leave_company_end ? formAdvanceData?.date_leave_company_end : ''}
                  onChange={(start: any, end: any) => {
                    setFormAdvanceData((prev) => ({ ...prev, date_leave_company_start: start, date_leave_company_end: end }))
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AlumniSection